/**
 * ╔════════════════════════════════════════════════════════════╗
 * ║  DISCOVERY CORE PHILOSOPHY                                 ║
 * ╠════════════════════════════════════════════════════════════╣
 * ║  Core Philosophy of Discovery: Thorough Exploration Before Execution  ║
 * ╚════════════════════════════════════════════════════════════╝
 */

export const DISCOVERY_CORE = `
# Discovery Phase Philosophy

Before any execution, thoroughly explore:
1. Workspace structure
2. Environment capabilities
3. Available skills and tools
4. Project patterns and conventions

The discovery phase sets the foundation for all subsequent actions.
`;
